import { CoachingTypeRepCard } from '../constant/Coaching-type-rep.constant';
import { CardItemType } from '../enums/card-item-type.enum';
import { determineActiveDays } from '../functions/determine-active-days.function';
import { AccordionChildItem } from '../models/accordion-child-item.model';
import { RepCardData } from '../models/rep-card-data.model';

export function goalToOppTransformer(
    data: RepCardData[],
    type?: CardItemType,
): AccordionChildItem[] {
    if (data == null || data.length === 0) {
        return [];
    }
    const items: AccordionChildItem[] = [];
    data.forEach((item, index) => {
        const childItem: AccordionChildItem = {
            isVisible: index < 3 || type === CardItemType.PENDING_COMMITMENTS,
            commitmentId: item.commitmentId,
            statusId: item.statusId,
            approvalId: item.approvalId,
            draftId: item.draftId,
            opportunityItem: {
                behaviour: item.behaviourName,
                subBehaviour: item.subBehaviourName,
                aligned: CoachingTypeRepCard[item.coachTypeId],
                goalKpi: item.metricName,
                pctImprovement: item.goal?.improvementSinceLastGoal,
                daysActive:
                    item.goal?.daysActive != null
                        ? item.goal?.daysActive
                        : determineActiveDays(item.activeDate),
                currentActual: item.goal?.currentActual,
                pctTarget: item.goal?.currentPctTarget,
                pctToGoal: item.goal?.currentPctGoal,
                lastUpdated: item.goal?.updatedOn ?? item.lastUpdatedOn,
                metricName: item.metricName,
                daysAsAnOpp: item.goal?.oppActiveDays,
                metricId: item.goal?.metricId,
            },
        };
        items.push(childItem);
    });
    return items;
}
